<style scoped>
    .invoice-editor{
        display: inline-block;
        vertical-align: middle;
    }
    .ivu-input{
        vertical-align: middle;
    }
    .edit-btn-col{
        padding: 0 2px;
    }
</style>
<template>
  <div class="invoice-editor">
    <v-btn @click="editNew">
      <v-icon>mdi-plus</v-icon>
      发票
    </v-btn>

    <Modal
      v-model="config.modal"
      title="添加/编辑发票"
      transfer
      width="900"
      :mask-closable="false"
      :loading="config.loading"
      ok-text="关闭"
      @on-ok="cancel"
    >
      <h2 />
      <Form
        ref="form"
        :model="edit_invoice"
        :label-width="100"
      >
        <Row>
          <i-col span="8">
            <FormItem label="录入人">
              {{ cur_customer.account }}
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="发票代码">
              <i-input
                v-model="edit_invoice.code"
                placeholder="发票代码"
                @on-change="uidChange(edit_invoice, 'code')"
              />
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem
              label="发票号码"
              prop="uid"
              :rules="{ validator:(...arg)=> validateCustom('uid',...arg) }"
            >
              <i-input
                v-model="edit_invoice.uid"
                placeholder="发票号码"
                @on-change="uidChange(edit_invoice, 'uid')"
              />
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem
              prop="invoice_type"
              label="发票类型" 
              :rules="{required: true, validator:(...arg)=> validateCustom('invoice_type',...arg) }"
            >
              <Select
                v-model="edit_invoice.invoice_type"
                placeholder="选择发票类型"
              >
                <Option
                  v-for="type in invoice_types"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col
            v-if="[0,1].includes(edit_invoice.invoice_type)"
            span="8"
          >
            <FormItem
              prop="invoice_form"
              label="发票形态"
              :rules="{required: true, validator:(...arg)=> validateCustom('invoice_form',...arg) }"
            >
              <Select
                v-model="edit_invoice.invoice_form"
                placeholder="选择发票形态"
              >
                <Option
                  v-for="status in invoice_status"
                  :key="status.value"
                  :value="status.value"
                >
                  {{ status.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <!-- </Row>
        <Row> -->
          <i-col span="8">
            <FormItem
              prop="total_price"
              label="发票金额"
              :rules="{required: true, validator:(...arg)=> validateCustom('total_price',...arg) }"
            >
              <input
                v-model="edit_invoice.total_price"
                class="ivu-input"
                type="number"
                placeholder="发票金额"
              ></input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="税前金额">
              <input
                v-model="edit_invoice.pretax_price"
                class="ivu-input"
                type="number"
                placeholder="税前金额"
              ></input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="税率(%)">
              <input
                v-model="edit_invoice.tax_rate"
                class="ivu-input"
                type="number"
                placeholder="税率(无需输入%)"
              ></input>
            </FormItem>
          </i-col>
          <!-- </Row>
        <Row> -->
          <i-col span="8">
            <FormItem label="税额">
              <input
                v-model="edit_invoice.tax"
                class="ivu-input"
                type="number"
                placeholder="税额"
              ></input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="开票日期">
              <DatePicker
                transfer
                type="date"
                :value="edit_invoice.invoice_date"
                placeholder="选择日期"
                @on-change="dateChange"
              />
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="认证月份">
              <DatePicker
                transfer
                type="month"
                :value="edit_invoice.use_month"
                placeholder="选择月份"
                @on-change="monthChange"
              />
            </FormItem>
          </i-col>
          <!-- </Row>
        <Row> -->
          <i-col span="8">
            <FormItem label="校验码">
              <input
                v-model="edit_invoice.check_code"
                class="ivu-input"
                type="number"
                placeholder="校验码"
              ></input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem
              prop="provider_type"
              label="发票提供方"
              :rules="{required: true, validator:(...arg)=> validateCustom('provider_type',...arg) }"
            >
              <Select
                v-model="edit_invoice.provider_type"
              >
                <Option
                  :value="0"
                >
                  业务申请方
                </Option>
                <Option
                  :value="1"
                >
                  财务
                </Option>
              </Select>
            </FormItem>
          </i-col> 
          <i-col span="8">
            <FormItem
              label="开票方"
              prop="code"
              :rules="{ validator:(...arg)=> validateCustom('',...arg) }"
            >
              <i-input
                v-model="edit_invoice.seller"
                placeholder="开票方"
              />
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem
              label="购买方"
              prop="code"
              :rules="{ validator:(...arg)=> validateCustom('code',...arg) }"
            >
              <i-input
                v-model="edit_invoice.buyer"
                placeholder="购买方"
              />
            </FormItem>
          </i-col>
        </Row>
        <FormItem label="发票备注">
          <i-input
            v-model="edit_invoice.remark"
            type="textarea"
            placeholder="备注"
          />
        </FormItem>
      </Form>
      <div class="line">
        <Row v-if="edit_invoice.id">
          <i-col
            class="edit-btn-col"
            span="12"
          >
            <Button
              long
              @click="editNew()"
            >
              取消修改
            </Button>
          </i-col>
          <i-col
            class="edit-btn-col"
            span="12"
          >
            <Button
              long
              type="primary"
              :loading="updating"
              @click="editOk"
            >
              确认修改
            </Button>
          </i-col>
        </Row>
        <Button
          v-else
          long
          type="primary"
          :loading="updating"
          @click="editOk"
        >
          新增发票
        </Button>
      </div>
      <div class="hr" />
      <div class="line">
        <h4>最近添加的发票</h4>
        <table class="mis-table">
          <thead>
            <tr>
              <th>发票代码</th>
              <th>发票号码</th>
              <th>发票类型</th>
              <th>发票总价</th>
              <th>税率(%)</th>
              <th>认证月份</th>
              <th>发票备注</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(invoice, index) in recent_invoices"
              :key="invoice.id"
            >
              <td>{{ invoice.code || '-' }}</td>
              <td>{{ invoice.uid || '-' }}</td>
              <td>{{ getInvoiceType(invoice.invoice_type) }}</td>
              <td>{{ formatPrice(invoice.total_price) }}</td>
              <td>{{ formatPrice(invoice.tax_rate) }}</td>
              <td>{{ invoice.use_month || '-' }}</td>
              <td>{{ invoice.remark || '-' }}</td>
              <td>
                <Button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="md-create"
                  @click="edit(invoice, index)"
                />
                <Poptip
                  confirm
                  title="你确定要删除吗?"
                  @on-ok="del(invoice)"
                >
                  <Button
                    size="small"
                    type="warning"
                    shape="circle"
                    :loading="deleting"
                    icon="md-close"
                  />
                </Poptip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  </div>
</template>
<script>
  import InvoiceUtil from '../libs/util';
  export default {
    props: {
      type: {
        type: String
      }
    },
    data() {
      this.invoice_status = InvoiceUtil.invoice_status
      return {
        config: {
          modal: false,
          loading: true
        },
        invoice_types: InvoiceUtil.invoice_types.filter(i => i.value >= 0),
        // 最近添加的发票
        recent_invoices: [],
        edit_invoice: {},
        new_invoice: {
          code: '',
          uid: '',
          invoice_type: null,
          total_price: 0,
          pretax_price: 0,
          tax: 0,
          tax_rate: 0,
          use_month: '',
          invoice_date: '',
          check_code: '',
          remark: '',
          provider_type: '',
          invoice_form: ''// 发票形态
        },
        updating: false,
        deleting: false
      }
    },
    computed: {
      //
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      this.cur_customer
      //this.getRecent();
    },
    mounted() {
      //
    },
    methods: {
      validateCustom(key, rule, value, callback) {
        let str = ''
        let code, uid, invoice_type_0
        const uid_patt = /^[a-zA-Z0-9]+$/;
       
        switch (key) {
        case 'total_price':
          if (value <= 0) {
            str = '发票金额必须大于0'
          } 
          break;
        case 'code':
        case 'uid':
          code = this.edit_invoice.code ? this.edit_invoice.code.trim() : '';
          uid = this.edit_invoice.uid ? this.edit_invoice.uid.trim() : '';
          invoice_type_0 = [0, 1].indexOf(this.edit_invoice.invoice_type) > -1
          if (!code && !uid) {
            str = '发票代码/发票号码不能同时为空';
          }
          if (invoice_type_0 && code && !str && !uid_patt.test(code)) {
            str = `请输入正确的发票代码`;
          }
          if (invoice_type_0 && uid && !str && !uid_patt.test(uid)) {
            str = `请输入正确的发票号码`;
          }
          break;
        case 'provider_type':
          if (['', undefined, null].includes(value)) {
            str = '必填'
          } 
          break
        case 'invoice_type':
          if (['', undefined, null].includes(value)) {
            str = '必填'
          } 
          break
        case 'invoice_form':
          if (!value) {
            str = '必选'
          }
          break
        default:
          break;
        }
        str ? callback(new Error(str)) : callback();
       
      },
      editNew() {
        this.$refs.form.resetFields()
        setTimeout(() => {
          this.edit_invoice = Util.clone(this.new_invoice);
          this.config.modal = true;
          this.getRecent();
        }, 200)
      },
      edit(invoice) {
        this.$refs.form.resetFields()
        setTimeout(() => {
          this.edit_invoice = Util.clone(invoice);
          this.config.modal = true;
          this.getRecent();
        }, 200)
      },
      getRecent() {
        Util.ajax.get(Util.api.query_recent_invoice).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.recent_invoices = res.data.invoices;
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        }).finally(() => {
        });
      },
      editOk() {
       
        this.$refs.form.validate((v) => {
          if (v) {
            this.updating = true;
            Util.ajax.post(Util.api.update_invoice, this.edit_invoice).then((response) => {
              return response.data;
            }).then((res) => {
              this.updating = false;
              if (res.code === 1) {
                const invoice = res.data.invoice;
                this.$util.insertOrUpdateArrayItem(this.recent_invoices, invoice, true);
                this.$emit('on-change', invoice);
                this.$Message.success('保存成功');
                this.config.modal = false
              } else {
                this.$Modal.warning({
                  title: '错误',
                  content: res.msg
                });
              }
            }).catch((e) => {
              this.updating = false;
              this.$Modal.warning({
                title: '错误',
                content: e.message
              });
            });
          }
        })
        //  if (this.updating) return;
        
       
      },
      del(invoice, index) {
        if (this.deleting) return;
        this.deleting = true;
        Util.ajax.post(Util.api.delete_invoice, invoice).then((response) => {
          return response.data;
        }).then((res) => {
          this.deleting = false;
          if (res.code === 1) {
            this.$Message.success('删除成功');
            this.$emit('delete', invoice);
            this.getRecent();
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.deleting = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      uidChange(invoice, key) {
        clearTimeout(this.invoice_uid_change_timer);
        this.invoice_uid_change_timer = setTimeout(() => {
          const info = invoice[key];
          const arr = info.split(/[,，]/);
          console.log(invoice.uid, arr);
          if (arr.length > 6) {
            if (arr[1] === '01') {
              invoice.invoice_type = 1;
            } else {
              invoice.invoice_type = 0;
            }
            invoice.code = arr[2].replace(/[^0-9]/g, '');
            invoice.uid = arr[3].replace(/[^0-9]/g, '');
            invoice.invoice_date = arr[5];
          }
        }, 500);
      },
      monthChange(month) {
        this.edit_invoice.use_month = month;
      },
      dateChange(date) {
        this.edit_invoice.invoice_date = date;
      },
      getInvoiceType(type) {
        return InvoiceUtil.getInvoiceType(type);
      },
      cancel() {
        this.config.modal = false;
      },
      formatPrice(price) {
        return Util.formatPrice(price);
      }
    }
  }
</script>
